const reportPlugin = {
  install: function (Vue, options) {
    /**
     * 数字转千分位，兼容小数情况
     * s 目标数字
     * n 保留小数点位数
     */
    Vue.filter('toThousands', (val = 0, digit = 2, prefix = '', suffix = '') => {
      val = val.toString()
      // if (/^-.*/.test(val)) { // 负数
      //   val = +val.replace(/^-.*/, '')
      //   prefix = '-'
      // }
      if (val === '--') return val
      if (/.*%$/.test(val)) { // 百分号
        val = +val.replace(/%/g, '')
        suffix = '%'
      }
      val = +val
      digit = digit > 0 && digit <= 20 ? digit : 2
      val = parseFloat((val + '').replace(/^\d\.-/g, '')).toFixed(digit) + ''
      const l = val.split('.')[0].split('').reverse()
      const r = val.split('.')[1]
      let t = ''
      for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
      }
      let res = t.split('').reverse().join('') + '.' + r
      res = res.replace(/\.00$/, '').replace(/^-,/, '-')
      return prefix + res + suffix
    })
    /* 掩藏手机号中间四位 */
    Vue.filter('coverPhone', (phone, perch = '*') => {
      if (typeof phone === 'number') {
        phone = phone.toString()
      }
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    })
    /* 将数字转换为‘万’为单位 */
    Vue.filter('tenThousand', (num = 0, digit = 10000, suffix = '万') => {
      return (num / digit).toFixed(2) + suffix
    })
    /* 文本超出显示省略号 */
    Vue.directive('ellipsis', {
      inserted(el, {value, modifiers}) {
        const text = el.innerHTML
        text.length > value && (el.innerHTML = `${text.substr(0, value)}...`)
        text.length > value && !modifiers.noTip && el.setAttribute('title', text)
      }
    })
  }
}

export default reportPlugin



// WEBPACK FOOTER //
// ./src/plugins/reportPlugin/index.js